import React from 'react';
import { useEffect, useState } from 'react';

//  React router
import {Route, Routes} from "react-router-dom";

//  Redux
import { Provider } from 'react-redux';
import { store } from './store';
import { setAccessTokenGetter } from './services/appliancemonitor';

//  Auth
import { useAuth0 } from "@auth0/auth0-react";

//  Primereact UI
//  (Full list of themes here: https://primereact.org/theming/)
import "primeflex/primeflex.css";                                       //flex
import "primereact/resources/primereact.min.css";                       //core css
import "primeicons/primeicons.css";                                     //icons

//  Global Styles
import './App.css';

//  App components
import NavBar from './components/common/NavBar';
import ApplianceMonitorHome from './components/ApplianceMonitorHome';
import NotFound from './components/common/NotFound';
import SettingsHome from "./components/settings/SettingsHome";
import AuthReceiver from "./components/common/AuthReceiver";

const App = () => {

    const {getAccessTokenSilently, isAuthenticated, isLoading} = useAuth0();
    const [isTokenGetterReady, setIsTokenGetterReady] = useState(!isAuthenticated);

    useEffect(() => {
        setIsTokenGetterReady(false);

        if (isAuthenticated) {
            setAccessTokenGetter(() => getAccessTokenSilently());
            setIsTokenGetterReady(true);

            return () => {
                setAccessTokenGetter(null);
                setIsTokenGetterReady(false);
            };
        }

        setAccessTokenGetter(null);
        setIsTokenGetterReady(true);
    }, [getAccessTokenSilently, isAuthenticated]);

    if (isLoading || !isTokenGetterReady) {
        return null;
    }

    //  Return the navbar and our target route
    return (
        <Provider store={store}>
            <NavBar/>
            <Routes>
                <Route path="/" element={<ApplianceMonitorHome/>}/>
                <Route path="/settings" element={<SettingsHome/>}/>
                <Route path="/auth" element={<AuthReceiver/>}/>
                <Route path="*" element={<NotFound/>} />
            </Routes>
        </Provider>
    );
}

export default App;
